import { RootState } from ".";
export const getscreen = (store: RootState) => store.screen;

export const getscore = (store: RootState) => store.score;
export const getuser = (store: RootState) => store.user;
export const getAuths = (store: RootState) => store.auth;